import { createApp } from "vue";
import App from "./App.vue";

import "@/assets/style.scss";

import AlzataVue from "alzata.ui.vue";

import fontAwesome from "./config/font-awesome";
import store from "./config/store";
import router from "./config/router";
import {
  getJson,
  postJson,
  putJson,
  doDelete,
  login,
  logout,
  register,
  recover,
  resetPassword,
  confirm,
  confirmInvite,
  getProfile,
  updateProfile,
} from "./apis/streib";

import SplashImage from "@/components/SplashImage.vue";

const app = createApp(App);

app.config.globalProperties.apiClient = {
  getJson,
  postJson,
  putJson,
  doDelete,
  login,
  logout,
  register,
  recover,
  resetPassword,
  confirm,
  confirmInvite,
  getProfile,
  updateProfile,
};

app.use(AlzataVue as any);
app.use(fontAwesome);
app.use(store);
app.use(router);

app.component("alzata-splash-image", SplashImage);

app.config.globalProperties.appSettings = {
  title: "DFOB",
  titleImageUrl: "/mainlogo.png",
};

app.mount("#app");
